import { Component } from '@angular/core';

@Component({
  selector: 'icon-clipboard',
  standalone: true,
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M5.33317 2.66671H3.99984C3.64622 2.66671 3.30708 2.80718 3.05703 3.05723C2.80698 3.30728 2.6665 3.64642 2.6665 4.00004V13.3334C2.6665 13.687 2.80698 14.0261 3.05703 14.2762C3.30708 14.5262 3.64622 14.6667 3.99984 14.6667H11.9998C12.3535 14.6667 12.6926 14.5262 12.9426 14.2762C13.1927 14.0261 13.3332 13.687 13.3332 13.3334V12M10.6665 2.66671H11.9998C12.3535 2.66671 12.6926 2.80718 12.9426 3.05723C13.1927 3.30728 13.3332 3.64642 13.3332 4.00004V6.66671M13.9998 9.33337H7.33317M7.33317 9.33337L9.99984 6.66671M7.33317 9.33337L9.99984 12M5.99984 1.33337H9.99984C10.368 1.33337 10.6665 1.63185 10.6665 2.00004V3.33337C10.6665 3.70156 10.368 4.00004 9.99984 4.00004H5.99984C5.63165 4.00004 5.33317 3.70156 5.33317 3.33337V2.00004C5.33317 1.63185 5.63165 1.33337 5.99984 1.33337Z" stroke="#2A4B5A" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `,
  styles: `
    svg{
        cursor: pointer;
        
        path{
            stroke: #2A4B5A;
            -webkit-transition: all .15s linear;
            -moz-transition: all .15s linear;
            -o-transition: all .15s linear;
            transition: all .15s linear;
        }

        &:hover{
            path{
                stroke: #11B7B7;
            }
        }
    }
  `
})
export class ClipBoardIconComponent {

}
